import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const GetDashboard = createAsyncThunk(
  "dashboard/GetDashboard",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/dashboard/`);
    return data
  }
);
